import { createStore } from 'redux';
// import logger from 'redux-logger';
import reducers from './reducers'
import middleware from './middleware'

export default createStore(reducers, middleware);
